/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import NavigationBreadcrumbs from '../../new_arch/components/NavigationBreadcrumbs/NavigationBreadcrumbs';
import { connectComponent } from '../../lib/connectComponent';
import { getAsset } from '../../selectors/assets';
import { getFolder } from '../../selectors/folders';
import { getProject } from '../../selectors/projects';
import { getSelectedAssetRoundOrCurrent } from '../../selectors/assetRounds';

import Asset from '../../entities/asset';
import Folder from '../../entities/folder';
import Project from '../../entities/project';
import Workspace from '../../entities/workspace';

import BreadcrumbLevelFactory from '../../factories/breadcrumbsFactory';
import HistoryPropType from '../../types/history';
import useBreadcrumbsConfig from './useBreadcrumbsConfig';

export const NavigationBreadcrumbsContainer = ( {
	project,
	folder,
	asset,
	selectedAssetRound,
	history
} ) => {
	const {
		firstItem,
		showBreadcrumbs,
		hideHomeIcon,
		hideFirstArrow,
		homeIconClickable,
		customHomeLogo
	} = useBreadcrumbsConfig( { project, folder, asset } );

	const ancestors = folder?.ancestors?.length > 0
		? folder?.ancestors.map( ancestor => ( { name: ancestor.name, url: ancestor.url } ) ) : [];

	const assetBreadcrumb = asset
		? { name: selectedAssetRound?.name || asset.name, url: asset.url }
		: undefined;

	const breadcrumbs = showBreadcrumbs ? BreadcrumbLevelFactory.arrayFrom( {
		levels: [
			firstItem,
			project ? { name: project.name, url: project.url } : undefined,
			...ancestors,
			folder ? { name: folder.name, url: folder.url } : undefined,
			assetBreadcrumb
		],
		history
	} ) : [];

	return (
		<NavigationBreadcrumbs
			breadcrumbs={breadcrumbs}
			linkURL="/projects"
			hideHomeIcon={hideHomeIcon}
			hideFirstArrow={hideFirstArrow}
			homeIconClickable={homeIconClickable}
			customHomeLogo={customHomeLogo}
		/>
	);
};

NavigationBreadcrumbsContainer.propTypes = {
	project: PropTypes.instanceOf( Project ),
	folder: PropTypes.instanceOf( Folder ),
	asset: PropTypes.instanceOf( Asset ),
	selectedAssetRound: PropTypes.shape( { name: PropTypes.string } ),
	workspaces: PropTypes.arrayOf( PropTypes.instanceOf( Workspace ) ),
	projectID: PropTypes.number,
	folderID: PropTypes.number,
	assetID: PropTypes.number,
	hideHomeIcon: PropTypes.bool,
	hideFirstArrow: PropTypes.bool,
	homeIconClickable: PropTypes.bool,
	history: HistoryPropType.isRequired
};

NavigationBreadcrumbsContainer.defaultProps = {
	project: undefined,
	folder: undefined,
	asset: undefined,
	selectedAssetRound: undefined,
	projectID: undefined,
	folderID: undefined,
	assetID: undefined,
	hideHomeIcon: false,
	hideFirstArrow: false,
	homeIconClickable: true
};

export default connectComponent( ( state, props ) => ( {
	asset: getAsset( state, props ),
	project: getProject( state, props ),
	folder: getFolder( state, props ),
	selectedAssetRound: getSelectedAssetRoundOrCurrent( state, props )
} ) )( withRouter( NavigationBreadcrumbsContainer ) );
